import React, { useState, useEffect, useRef } from 'react';
import './ViewerLayoutWrap.less';
import { Spin } from 'antd';

const ViewerLayoutWrap = ({ iframeUrl }) => {
  const iframeRef = useRef();

  useEffect(() => {
    if (iframeRef && iframeRef.current) {
      // iframeRef.setAttribute("src",iframeUrl)
      iframeRef.current.src = iframeUrl;
    }
  }, [iframeUrl]);

  return (
    <div className="viewer-main-page">
      <div
        style={
          iframeUrl ? { display: 'block', width: '100%', height: '100%' } : { display: 'none' }
        }
      >
        <iframe
          id="iframeEle"
          ref={iframeRef}
          src="/viewer"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
      <div style={!iframeUrl ? { display: 'block', height: '100%' } : { display: 'none' }}>
        <p className="tips">请先选中病人记录!</p>
      </div>
    </div>
  );
};

export default ViewerLayoutWrap;
